import PropTypes from 'prop-types'
import React from 'react'

import LinkInlineArrowShort from 'components/LinkInlineArrowShort'
import { privacy as privacyPage, terms } from 'routes'
import { TextLH, CartText } from 'styles/components/typography'

import { LinkStyled, TextSpan } from './styles'

const CheckboxTerms = ({
  locale,
  agreement,
  isOldPattern,
  textSize,
  withArrow,
  rules,
  privacy,
}) => {
  const rulesLink = rules ? rules : terms.as(locale)
  const termsLink = withArrow ? (
    <LinkInlineArrowShort
      isHoverInverted={true}
      classNameArrow="no-animation"
      as="a"
      to={rulesLink}
    >
      {agreement.terms}
    </LinkInlineArrowShort>
  ) : (
    <LinkStyled
      component="a"
      isTargetBlank={true}
      to={rulesLink}
      asPath={rulesLink}
    >
      <TextSpan
        as={textSize}
        dangerouslySetInnerHTML={{ __html: agreement.terms }}
      />
    </LinkStyled>
  )

  const privLink = privacy ? privacy : privacyPage.as(locale)
  const privacyLink = withArrow ? (
    <LinkInlineArrowShort
      isHoverInverted={true}
      classNameArrow="no-animation"
      as="a"
      to={privLink}
    >
      {agreement.privacy}
    </LinkInlineArrowShort>
  ) : (
    <LinkStyled
      component="a"
      isTargetBlank={true}
      to={privLink}
      asPath={privLink}
    >
      <TextSpan
        as={textSize}
        dangerouslySetInnerHTML={{ __html: agreement.privacy }}
      />
    </LinkStyled>
  )

  const splitTerms = agreement[isOldPattern ? 'pattern_old' : 'pattern'].split(
    '<%= terms %>',
  )
  const privacyOrder = splitTerms[0].includes('<%= privacy %>') ? 0 : 1
  const splitPrivacy = splitTerms[privacyOrder].split('<%= privacy %>')

  return (
    <>
      <TextSpan
        as={textSize}
        dangerouslySetInnerHTML={{
          __html: privacyOrder ? splitTerms[0] : splitPrivacy[0],
        }}
      />
      {privacyOrder ? termsLink : privacyLink}
      <TextSpan
        as={textSize}
        dangerouslySetInnerHTML={{
          __html: splitPrivacy[+!privacyOrder],
        }}
      />
      {privacyOrder ? privacyLink : termsLink}
      <TextSpan
        as={textSize}
        dangerouslySetInnerHTML={{
          __html: privacyOrder ? splitPrivacy[1] : splitTerms[1],
        }}
      />
    </>
  )
}

CheckboxTerms.propTypes = {
  locale: PropTypes.string.isRequired,
  agreement: PropTypes.shape({
    terms: PropTypes.string.isRequired,
    privacy: PropTypes.string.isRequired,
    pattern: PropTypes.string.isRequired,
  }),
  privacy: PropTypes.string,
  rules: PropTypes.string,
  isOldPattern: PropTypes.bool,
  textSize: PropTypes.oneOf([TextLH, CartText]),
  withArrow: PropTypes.bool,
}

CheckboxTerms.defaultProps = {
  isOldPattern: false,
  textSize: TextLH,
  withArrow: true,
}

export default React.memo(CheckboxTerms)
